import { render, staticRenderFns } from "./LenovoSelectModule.vue?vue&type=template&id=49070805"
import script from "./LenovoSelectModule.vue?vue&type=script&lang=js"
export * from "./LenovoSelectModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports